import React, { useState, useEffect } from 'react';
import Modal from '../../../BaseComponents/Modal';
import Button from '../../../BaseComponents/Button';
import { Quote, getQuoteById } from '../../../../api/quotes';
import './QuotesModal.scss';
import trash from "../../../../assets/icons/TrashBin2.svg";

type Props = {
    isOpen: boolean;
    onClose: () => void;
    quote: Quote | null;
    onEdit?: (quote: Quote) => void;
    onDelete?: (quote: Quote) => void;
};

const PLAN_MAP: Record<string, string> = {
    'core': 'Core',
    'plus': 'Plus',
    'scan': 'Scan',
    'free': 'Free'
};

const ViewQuoteModal: React.FC<Props> = ({ isOpen, onClose, quote, onEdit, onDelete }) => {
    const [fetchedQuote, setFetchedQuote] = useState<Quote | null>(null);
    const [isLoading, setIsLoading] = useState(false);

    const lastFetchedIdRef = React.useRef<number | null>(null);

    useEffect(() => {
        if (isOpen && quote?.id && lastFetchedIdRef.current !== quote.id) {
            lastFetchedIdRef.current = quote.id;
            setIsLoading(true);
            getQuoteById(quote.id)
                .then(data => setFetchedQuote(data))
                .catch(() => setFetchedQuote(quote)) // fallback to passed quote
                .finally(() => setIsLoading(false));
        }
    }, [isOpen, quote]);

    const displayQuote = fetchedQuote || quote;
    if (!displayQuote) return null;

    const handleEdit = () => {
        if (onEdit && displayQuote) {
            onEdit(displayQuote);
            onClose();
        }
    };

    const handleDelete = () => {
        if (onDelete && displayQuote) {
            onDelete(displayQuote);
        }
    };

    return (
        <Modal 
            isOpen={isOpen} 
            onClose={onClose}
            title="Quote"
            width="800px"
        >
            <div className="view-quote-modal">
                {isLoading ? (
                    <div style={{ padding: '40px', textAlign: 'center', color: '#6b7280' }}>Loading...</div>
                ) : (
                    <div className="quote-details">
                        <div className="detail-field">
                            <label className="field-label">Quote</label>
                            <div className="field-value">{displayQuote.quote}</div>
                        </div>

                        <div className="detail-field">
                            <label className="field-label">Plans</label>
                            <div className="field-value">
                                {displayQuote.plans && displayQuote.plans.length > 0 
                                    ? displayQuote.plans.map(p => PLAN_MAP[p] || p).join(', ')
                                    : 'No plans assigned'
                                }
                            </div>
                        </div>
                    </div>
                )}

                <div className="modal-actions">
                    <Button
                        text="Edit"
                        onClick={handleEdit}
                        isSecondary={false}
                        width="100%"
                        backgroundColor="#238698"
                        color="#ffffff"
                    />
                    <button 
                        className="delete-button"
                        onClick={handleDelete}
                    >
                        <img src={trash} alt="delete" />
                        Delete quote
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default ViewQuoteModal;
